var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor forward-to-chatbot" }, [
    _c("div", { staticClass: "title" }, [_vm._v("Select chatbot to forward")]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c(
        "div",
        { staticClass: "attribute-picker-section" },
        [
          _c("span", { staticClass: "sectionTitle" }, [
            _vm._v(" Choose Chatbot Story From List"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "select-filetype",
              model: {
                value: _vm.clone.storyId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "storyId", $$v)
                },
                expression: "clone.storyId",
              },
            },
            _vm._l(_vm.stories, function (story) {
              return _c(
                "a-select-option",
                { key: story._id, attrs: { value: story._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(story.title) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }